export const environment = {
    "configuration": "DEBUG",
    "production": false,
    "log_level": "Debug",
    "print_logs": true,
    developer_console_enabled: false,
    type: 'stage',
    outlook_group_graph_enabled: false,
    "tones": {
        "default": {
            "ATTACH-DOCUMENT-TONE": " Answer the following question using only the data provided in the 'Sources' section of message. Your answer can't include assumptions and other sources rather than information from message.",
            "formal": "\nYou are 'R2 Copilot' - an intelligent assistant.\nThe writing style is formal.",
            "informal": "\nYou are 'R2 Copilot' - an intelligent assistant.\nThe writing style is informal."
        },
        "-1008236542": {
            "ATTACH-DOCUMENT-TONE": " Ответьте на следующий вопрос, используя только данные, указанные в разделе «Sources» сообщения. Ваш ответ не может включать предположения и другие источники, а не информацию из сообщения.",
            "formal": "\nТы - 'R2 Copilot' ИИ помощник анализирующий документы компании и предоставлюящий результаты поиска по ним.\nСтиль написания - формальный.",
            "informal": "\nТы - 'R2 Copilot' ИИ помощник анализирующий документы компании и предоставлюящий результаты поиска по ним.\nСтиль написания - неформальный."
        }
    },
    "prompts_divider": 800,
    "limits_bytes": {
        "TONE": 100,
        "SEND_MESSAGE": 29000,
        "ATTACH_SELECTED": 29000,
        "ATTACH_DOCUMENT": 29000,
        "ATTACH_HISTORY": 29000,
        "WHOLE_MESSAGE": 58000,
        "QUICK_ACTIONS": 160,
    },
    history_count_message: 2,
    historyVersion: 1,
    office_api_host: 'https://web-chat-stage.r2copilot.ai',
    health_api_host: 'https://health-stage.r2copilot.ai',
    preserve_chat_composer_draft: false,
    secure_transport_enabled: false,
    check_health: true,
    default_locale: 'en',
    redirect_path_name: '/auth/callback',
    msal_client_id: '1b672743-63af-4b75-b6d0-8760547b7a7c',
    msal_authority: 'https://login.microsoftonline.com/common',
    msal_dialog_path: '/auth/msal-dialog',
    db: {
        name: 'r2-copilot',
        version: 1,
    },
    input_action_polling_interval_in_ms: 1000,
    subscription_polling_interval_in_ms: 3 * 60 * 1000,
    animation_delay_in_ms: {
        trigger: 120,
    },
    office_core_version: 1,
};
